export function formatLabel(
  entity:
    | { name: string; code: string }
    | { value: string; code: string }
    | undefined,
) {
  if (!entity) return '';
  if ('name' in entity) {
    return `${entity.name} (${entity.code})`;
  }
  return `${entity.value} (${entity.code})`;
}
